(function () {
  const STICKY_FORM_SELECTOR = 'product-add-to-cart-sticky form[data-type="add-to-cart-form"]';
  const BOOKING_BUTTON_SELECTOR = '.futureblink-booking-button, button.futureblink-booking-button';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function formatBirthDateTime(dateValue, timeValue) {
    if (!dateValue || !timeValue) return '';

    const [year, month, day] = dateValue.split('-').map(Number);
    const [hours, minutes] = timeValue.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12 || 12;

    return `${pad(day)}/${pad(month)}/${year}, ${hours12}:${pad(minutes)} ${period}`;
  }

  function syncDatetimeWrapper(wrapper) {
    const dateInput = wrapper.querySelector('[data-birth-date]');
    const timeInput = wrapper.querySelector('[data-birth-time]');
    const hiddenInput = wrapper.querySelector('[data-birth-datetime-value]');
    if (!dateInput || !timeInput || !hiddenInput) return;

    hiddenInput.value = formatBirthDateTime(dateInput.value, timeInput.value);
  }

  function syncAllBirthDatetimes() {
    document.querySelectorAll('[data-birth-datetime]').forEach(syncDatetimeWrapper);
  }

  function getBirthDetailsRoot() {
    return document.querySelector('[data-product-birth-details]');
  }

  function isBookingProductPage() {
    const productForm = document.querySelector('product-form[data-birth-details-enabled="false"]');
    if (productForm) return true;
    return Boolean(document.querySelector(BOOKING_BUTTON_SELECTOR));
  }

  function clearBirthDetailsGating(sectionId) {
    if (sectionId) {
      getSubmitButtons(sectionId).forEach((button) => {
        button.removeAttribute('disabled');
        button.removeAttribute('data-birth-incomplete');
        button.removeAttribute('aria-disabled');
      });
      setPaymentButtonState(getPaymentButtonContainer(sectionId), false);
    }
  }

  function removeBirthDetailsForBooking() {
    const birthDetails = getBirthDetailsRoot();
    const sectionId =
      birthDetails?.dataset.sectionId ||
      document.querySelector('product-form')?.dataset.sectionIdPdp;

    if (birthDetails) {
      birthDetails.remove();
    }

    clearBirthDetailsGating(sectionId);

    document.querySelectorAll('[data-birth-field]').forEach((field) => {
      field.removeAttribute('required');
    });
  }

  function watchForBookingButton() {
    const buttonsRow = document.querySelector('.product-form__buttons');
    if (!buttonsRow) return;

    const check = () => {
      if (!document.querySelector(BOOKING_BUTTON_SELECTOR)) return;
      removeBirthDetailsForBooking();
    };

    check();

    const observer = new MutationObserver(check);
    observer.observe(buttonsRow, { childList: true, subtree: true });
  }

  function getBirthFields(formId) {
    return Array.from(document.querySelectorAll(`[data-birth-field][form="${formId}"]`));
  }

  function isBirthFormComplete(formId) {
    const fields = getBirthFields(formId);
    if (!fields.length) return true;

    syncAllBirthDatetimes();

    return fields.every((field) => {
      const value = field.value?.trim();
      return value !== '' && field.checkValidity();
    });
  }

  function isVariantUnavailable(birthDetails) {
    return birthDetails?.dataset.variantUnavailable === 'true';
  }

  function getSubmitButtons(sectionId) {
    return [
      document.getElementById(`ProductSubmitButton-${sectionId}`),
      document.getElementById(`StickyProductSubmitButton-${sectionId}`),
    ].filter(Boolean);
  }

  function getPaymentButtonContainer(sectionId) {
    const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    return submitButton?.closest('.product-form__buttons')?.querySelector('.shopify-payment-button') || null;
  }

  function setPaymentButtonState(paymentContainer, disabled) {
    if (!paymentContainer) return;

    paymentContainer.classList.toggle('product-birth-details__payment--disabled', disabled);

    paymentContainer.querySelectorAll('button, .shopify-payment-button__button').forEach((button) => {
      if (disabled) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function updatePurchaseButtonsState() {
    const birthDetails = getBirthDetailsRoot();
    if (!birthDetails) return;

    const formId = birthDetails.dataset.productFormId;
    const sectionId = birthDetails.dataset.sectionId;
    if (!formId || !sectionId) return;

    const complete = isBirthFormComplete(formId);
    const variantUnavailable = isVariantUnavailable(birthDetails);
    const shouldDisable = variantUnavailable || !complete;

    getSubmitButtons(sectionId).forEach((button) => {
      if (variantUnavailable) {
        button.removeAttribute('data-birth-incomplete');
        return;
      }

      if (shouldDisable) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('data-birth-incomplete', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('data-birth-incomplete');
      }
    });

    setPaymentButtonState(getPaymentButtonContainer(sectionId), shouldDisable);
  }

  function initVariantAvailabilityState(birthDetails, sectionId) {
    const mainSubmit = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const unavailable =
      mainSubmit?.hasAttribute('disabled') && !mainSubmit.hasAttribute('data-birth-incomplete');
    birthDetails.dataset.variantUnavailable = unavailable ? 'true' : 'false';
  }

  function validateBirthFields(formId) {
    syncAllBirthDatetimes();

    const fields = getBirthFields(formId);
    if (!fields.length) return true;

    let valid = true;
    fields.forEach((field) => {
      if (!field.checkValidity()) {
        valid = false;
        field.reportValidity();
      }
    });
    return valid;
  }

  function syncVariantToMainForm(stickyForm, mainForm) {
    const stickyVariant = stickyForm.querySelector('[name="id"]');
    const mainVariant = mainForm.querySelector('[name="id"]');
    if (stickyVariant && mainVariant) {
      mainVariant.value = stickyVariant.value;
      mainVariant.disabled = stickyVariant.disabled;
    }
  }

  function isStickyForm(form) {
    return Boolean(form.closest('product-add-to-cart-sticky'));
  }

  function handleProductFormSubmit(event) {
    const productForm = event.target.closest('product-form');
    if (!productForm) return;

    if (isBookingProductPage()) return;

    const submittedForm = event.target;
    const birthDetails = getBirthDetailsRoot();
    if (!birthDetails) return;

    const mainFormId = birthDetails.dataset.productFormId;
    const mainForm = document.getElementById(mainFormId);
    if (!mainForm) return;

    if (isStickyForm(submittedForm)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      syncVariantToMainForm(submittedForm, mainForm);
      if (!validateBirthFields(mainFormId)) return;

      if (typeof mainForm.requestSubmit === 'function') {
        mainForm.requestSubmit();
      } else {
        mainForm.submit();
      }
      return;
    }

    if (submittedForm.id !== mainFormId) return;
    if (!validateBirthFields(mainFormId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function handlePaymentButtonClick(event) {
    const birthDetails = getBirthDetailsRoot();
    if (!birthDetails) return;

    const paymentButton = event.target.closest('.shopify-payment-button');
    if (!paymentButton || paymentButton.classList.contains('product-birth-details__payment--disabled')) {
      return;
    }

    const formId = birthDetails.dataset.productFormId;
    if (!isBirthFormComplete(formId)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      validateBirthFields(formId);
      updatePurchaseButtonsState();
    }
  }

  function bindBirthFieldListeners(formId) {
    getBirthFields(formId).forEach((field) => {
      field.addEventListener('input', updatePurchaseButtonsState);
      field.addEventListener('change', updatePurchaseButtonsState);
    });
  }

  function initBirthDatetimePickers() {
    document.querySelectorAll('[data-birth-datetime]').forEach((wrapper) => {
      const dateInput = wrapper.querySelector('[data-birth-date]');
      const timeInput = wrapper.querySelector('[data-birth-time]');
      const pickers = wrapper.querySelectorAll('.product-birth-details__picker');

      const handleChange = () => {
        syncDatetimeWrapper(wrapper);
        updatePurchaseButtonsState();
      };

      if (dateInput) dateInput.addEventListener('change', handleChange);
      if (dateInput) dateInput.addEventListener('input', handleChange);
      if (timeInput) timeInput.addEventListener('change', handleChange);
      if (timeInput) timeInput.addEventListener('input', handleChange);

      pickers.forEach((picker) => {
        picker.addEventListener('click', (event) => {
          const input = picker.querySelector('input');
          if (!input || event.target === input) return;
          input.focus();
          if (typeof input.showPicker === 'function') {
            try {
              input.showPicker();
            } catch (error) {
              /* showPicker may throw if not triggered by user gesture */
            }
          }
        });
      });
    });
  }

  function observePaymentButton(sectionId) {
    const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const buttonsRow = submitButton?.closest('.product-form__buttons');
    if (!buttonsRow) return;

    const observer = new MutationObserver(() => updatePurchaseButtonsState());
    observer.observe(buttonsRow, { childList: true, subtree: true });
  }

  function initBirthDetailsGating() {
    if (isBookingProductPage()) {
      removeBirthDetailsForBooking();
      watchForBookingButton();
      return;
    }

    const birthDetails = getBirthDetailsRoot();
    if (!birthDetails) {
      watchForBookingButton();
      return;
    }

    const formId = birthDetails.dataset.productFormId;
    const sectionId = birthDetails.dataset.sectionId;
    if (!formId || !sectionId) return;

    initVariantAvailabilityState(birthDetails, sectionId);
    bindBirthFieldListeners(formId);
    initBirthDatetimePickers();
    observePaymentButton(sectionId);
    updatePurchaseButtonsState();
    watchForBookingButton();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event?.data || String(event.data.sectionId) !== String(sectionId)) return;

        const variant = event.data.variant;
        const unavailable = !variant || variant.available === false;
        birthDetails.dataset.variantUnavailable = unavailable ? 'true' : 'false';
        updatePurchaseButtonsState();
      });
    }
  }

  document.addEventListener('submit', handleProductFormSubmit, true);
  document.addEventListener('click', handlePaymentButtonClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBirthDetailsGating);
  } else {
    initBirthDetailsGating();
  }

  window.ProductBirthDetails = {
    updatePurchaseButtonsState,
    isBirthFormComplete,
  };
})();
